import StateStore from '../store/state-store';
import {State} from '../../entity/model/state';

export default class StateService {
  stateStore: StateStore;

  constructor(stateStore: StateStore) {
    this.stateStore = stateStore;
  }

  getStates = async (): Promise<State[]> => {
    return this.stateStore.cache
      ? this.stateStore.states.sort((a: State, b: State) => a.shortName.localeCompare(b.shortName))
      : (await this.stateStore.getStates()).sort((a: State, b: State) => a.shortName.localeCompare(b.shortName));
  }

  getStateById = async (stateId: string): Promise<State | undefined> => {
    return stateId !== null ? (await this.getStates()).find((state: State) => state.id === stateId) : undefined;
  }
}